<div
  id="add-alert-cc"
  class="cc-renderer-container"
  role="button"
  tabindex="0"
  [attr.aria-expanded]="expanded"
  (mousedown)="onMouseDown($event)"
  (click)="onExpandClick($event)"
  (focusout)="onFocusOut()"
  [class.expanded]="expanded"
>
  <form [formGroup]="ccForm">
    <app-input-chips
      #ccChips
      placeHolder="Enter Cc recipients..."
      [chips]="pending"
      (chipsChange)="onChipsChange($event)"
      controlName="ccAlert"
      [separatorKeysCodes]="separatorKeysCodes"
      [maxVisibleRows]="maxVisibleRows"
      [forceShowAll]="expanded"
      [maxListHeight]="maxListHeight"
      [color]="'primary'"
    >
    </app-input-chips>
  </form>
</div>
